const toolbox = [
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_LED}',
    categorystyle: 'led_category',
    cssConfig: {
      icon: 'customIcon categoryIfzero categoryIfblock'
    },
    contents: [
      {
        kind: 'block',
        type: 'common_color'
      },
      {
        kind: 'block',
        type: 'machine_ifzero_led'
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_SENSOR}',
    categorystyle: 'sensor_category',
    cssConfig: {
      icon: 'customIcon categoryIfzero categoryIfblock'
    },
    contents: [
      {
        kind: 'block',
        type: 'machine_ifzero_bmp_get'
      },
      {
        kind: 'block',
        type: 'machine_ifzero_mpu_get'
      }
    ]
  }
]

export default toolbox
